<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Register Expense for Decree Number '{{inner_Calibration.letterRequestSchduleCustomer_id}}'</h5>
      <form [formGroup]="FundsForm" (submit)="OnSubmit()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6" *ngIf="inner_Funds.id==0">
            <label for="exampleInputEmail1">Expense Date</label>
            <input type="text" formControlName="Date"  #datepickerBuy placeholder="Type here..."   class="form-control" />
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerBuy"></ng-persian-datepicker>
          </div>
          <div class="form-group col-md-6" *ngIf="inner_Funds.id>0">
            <label for="exampleInputEmail1">Expense Date</label>
            <input type="text" value="{{get_Form_Date().value}}" disabled placeholder="Type here..."   class="form-control" />

          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Expense Title</label>
            <select class="custom-select" formControlName="Title_Id">
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_Title" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Expense Amount (IRR) </label>
            <input formControlName="Price" (keyup)="pishPardakht_Change()" type="number" class="form-control" placeholder="Type here...">
            <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched" class="form-text text-muted MyErrorRedColor">Enter the expense amount (IRR).</small>
          </div>
          <div class="form-group col-md-8">
            <label for="exampleInputEmail1">Expense Amount in Words </label>
            <input formControlName="PriceAlpah" disabled type="text" class="form-control">
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">
              Attachment
              <button (click)="Remove_uploadSrc()"  type="button" *ngIf="inner_Funds.src"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_Src" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_Src" #file_Src (change)="uploadSrc(file_Src.files)" type="file" class="form-control"  placeholder="Type here...">
            <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Funds/{{inner_Funds.src}}"   *ngIf="inner_Funds.src" ><i class="fa fa-download"></i> Download </a>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Description</label>
            <input formControlName="Dsc" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched" class="form-text text-muted MyErrorRedColor">Enter the description.</small>
          </div>
        </div>

        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing && this.inner_Funds.id==0" type="submit" [disabled]="!FundsForm.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
        <button *ngIf="!InProccessing  && this.inner_Funds.id>0" type="submit" [disabled]="!FundsForm.valid" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-edit"></i> Edit </button>

      </form>

  </div>
</div>
